import React, { useEffect } from "react";
import {
  Box,
  Button,
  Paper,
  Typography,
  Divider,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from "axios";
import BlockIcon from "@mui/icons-material/Block";
import { getLocalValue, LoacalVariables } from "../commonFunctions/CommonFunctions";
import { ipUrl } from "../Config/url";

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const userType = getLocalValue(LoacalVariables.UserType);
  const name = getLocalValue(LoacalVariables.Name);
  const userId = getLocalValue(LoacalVariables.UserId);

  // Optional: log unauthorized access
  useEffect(() => {
    const logAccessDenial = async () => {
      try {
       let response = await axios.post(
          `${ipUrl}/api/logs/unauthorized-access`,
          {
            userId,
            userType,
            name,
            path: window.location.pathname,
            attemptedAt: new Date(),
          },
          { withCredentials: true }
        );
      } catch (err) {
        console.error("Failed to log unauthorized access", err);
      }
    };

    logAccessDenial();
  }, [userId, userType, name]);

  return (
    <>
      <Helmet>
        <title>Unauthorized | Willsoar Technologies</title>
        <meta
          name="description"
          content="Oops! You don’t have permission to access this page."
        />
      </Helmet>

      <Box
        sx={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #1e1e2f, #2c3e50)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Paper
          elevation={4}
          sx={{
            p: 5,
            maxWidth: 500,
            width: "100%",
            borderRadius: 4,
            textAlign: "center",
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          <BlockIcon sx={{ fontSize: 60, color: theme.palette.error.main, mb: 2 }} />
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" gutterBottom>
            Hello <strong>{name || "User"}</strong>, your role is:{" "}
            <strong style={{ color: "#FFC107" }}>{userType}</strong>
          </Typography>
          <Typography variant="body2" sx={{ color: "#ccc", mt: 1 }}>
            You don’t have permission to access this page.
          </Typography>

          <Divider sx={{ my: 3, borderColor: "rgba(255,255,255,0.2)" }} />

          <Typography
            variant="body2"
            sx={{ fontStyle: "italic", color: "#aaa", mb: 3 }}
          >
            If you believe this is an error, please contact your system
            administrator.
          </Typography>

          <Button
            variant="contained"
            size="large"
            sx={{ borderRadius: 2,backgroundColor:"#4DD26B" }}
            onClick={() => navigate("/")}
          >
            Go to Home
          </Button>
        </Paper>
      </Box>
    </>
  );
};

export default Unauthorized;